<template>

  <div style="width: 100%">

    <vs-popup :fullscreen="false" :buttonCloseHidden="false" :active.sync="popupActive" title="Table of content">
      <div style="overflow-y: scroll;width: 100% ; font-size: large ; color: black" v-html="toc"
           @click='onTocClick($event)'></div>
    </vs-popup>

    <div class="section" id="buttons" >
      <vs-row>

        <vs-button  @click="showChapterMenu($event)" color="primary"  icon-pack="feather" class="mobileHide"
                    icon="icon-list">Free Chapters</vs-button>&nbsp;

        <vs-button class="mobileHide" @click="showToc" color="primary" type="border" id="tocButton" style="float: left">
          <vs-icon icon-pack="feather" icon="icon-file-text"><span style="font-weight: bold;margin: 0;padding: 0"></span>
          </vs-icon>
        </vs-button>



        <vs-button v-bind:style="{ display: fullScreenButton }" @click="openFull" color="warning" type="border"
                   icon-pack="feather" style="float: left;margin-left: 5px"
                   icon="icon-maximize-2">
        </vs-button>

      </vs-row>

    </div>


    <div class="bookCenter">
      <div class="book" v-html="content" id="bookHtml" @click='onBookClick($event)'
           v-on:scroll.passive="onBookScroll($event)"
           v-bind:style="{ maxHeight: iFrameHeight + 'px' }" style="overflow-y: auto;font-size: large ; color: black;">

      </div>

      <div class="section chessboard" id="chess">
        <mychessboard v-bind:style="{ display: showBoard }" ref="chessboard" @onShowToc="showToc"
                      @onBoardFenChanged="onUserMove" @showChapterMenu="showChapterMenu"></mychessboard>

      </div>
    </div>

    <vue-context ref="chooseChapterMenu" style="max-width: 350px">
      <li style="cursor:pointer;color: #191970;overflow: hidden">
        <a style="cursor:pointer;color: #191970;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"  @click="loadChapter(0)">Cover</a>
      </li>
      <li style="cursor:pointer;color:#191970;" v-for="chapter in chapters">
        <a style="color: #191970;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" @click="loadChapter(chapter.chapter)">{{
          chapter.title }}</a>
      </li>
    </vue-context>

  </div>


</template>

<script>
    import 'firebase/auth'
    import {VueContext} from 'vue-context';

    export default {
        components: {
            VueContext
        },
        data() {
            return {
                popupActive: false,
                chapterNumber: 0,
                chapterTitle: 'uknown',
                backgroundLoading: 'primary',
                colorLoading: 'primary',
                engine: false,
                engineLine: '',
                colorx: 'success',
                html: '',
                iFrameHeight: 500,
                title: this.$store.state.books.readingBook.title,
                lastScrollTime: 0,
                updateScrollTime: false,
                activeLoading: false,
                fullScreenButton: "inline",
                showBoard: "block",
                showEngine: "block"
            }
        },
        beforeDestroy() {
            if (this.$refs.engine) {
                this.$refs.engine.stopEngine();
            }

        },
        created() {
            this.updateScrollTime = false;
        },
        mounted() {
            this.bookId = this.$route.query.id;

            if (this.bookId) {
                this.resizeBookHeigh();

                this.$store.dispatch('books/loadBookMappings',
                    {
                        id: this.bookId,
                        chapterFile: undefined
                    }, {root: true}
                );

                this.fullScreenButton = this.inFrame() ? 'inline' : 'none';

            } else {
                this.$router.push("/pages/error-404")
            }
        },
        computed: {
            content() {
                if (this.$store.state.books.chapterContent) {
                    this.$refs.chessboard.setBookMovesMappings(this.$store.state.books.bookMoves);
                    return this.$store.state.books.chapterContent;
                } else {
                    return "<img style='max-width: 200px;height: auto' src=\"loading-gif-icon-9.jpg\"/>";
                }
            },
            toc() {
                this.$vs.loading.close();
                return this.$store.state.books.toc;
            },
            chapters(){
                return this.$store.state.books.bookMappings.chapterMappings;
            }
        },
        methods: {
            resizeBookHeigh() {
                let body = document.body;
                this.iFrameHeight = body.clientHeight - document.getElementById("tocButton").clientHeight;

                if (document.body.clientWidth < 600) {

                    if( this.inFrame() ){
                        document.getElementById("buttons").style.display = 'block';
                    }
                    else{
                        document.getElementById("buttons").style.display = 'none';
                    }

                    if( this.showBoard === 'block' ){
                        let temp = this;
                        setTimeout(function () {
                            temp.iFrameHeight = temp.iFrameHeight - document.getElementById("chess").clientHeight;
                        }, 500);
                    }
                    else{
                        this.iFrameHeight = this.iFrameHeight - 50;
                    }
                }

                // console.log(this.iFrameHeight);

            },
            hideBoard() {
                this.showBoard = this.showBoard === 'block' ? 'none' : 'block';
                this.resizeBookHeigh();
            },
            hideEngine() {
                this.showEngine = this.showEngine === 'block' ? 'none' : 'block';
            },
            openFull() {
                var ts = Math.round((new Date()).getTime() / 1000);
                var win = window.open(document.location+"&t="+ts, '_blank');
                win.focus();
            },
            inFrame() {
                try {
                    return window.self !== window.top;
                } catch (e) {
                    return true;
                }
            },
            onUserMove(fen) {

                if( fen === undefined){
                    this.resizeBookHeigh();
                }
            },
            showChapterMenu(event){
                event.stopPropagation();
                event.preventDefault();
                this.$refs.chooseChapterMenu.open(event);
            },
            onEngineSetFen(fen) {
                // console.log("on engine set fen event" + fen);
                this.$refs.chessboard.setFEN(fen);
            },
            onBookScroll(event) {
                let time = Date.now();

                // console.log(this.updateScrollTime);

                if (time - this.lastScrollTime > 200) {
                    localStorage.setItem("scrollTop", event.target.scrollTop);
                }
            },
            updateScroll() {

                setTimeout(function () {
                    document.getElementById("bookHtml").scrollTop = 0;
                }, 1000);

            },
            handleOnMoveClick(href) {
                // console.log("Handle ref: " + href);

                if (href) {
                    if (href.includes('SetMove')) {
                        href = href.substring(href.indexOf("SetMove"));
                        href = href.substring(8, href.length - 1);
                        // console.log("cmd : " + href);
                        this.showBoard = 'block';
                        this.$refs.chessboard.setMoveCommand(href);
                        return true;
                    } else if (href.includes('GoToGame')) {
                        href = href.substring(href.indexOf("GoToGame"));
                        href = href.substring(9, href.length - 1);
                        // console.log("cmd : " + href);
                        this.showBoard = 'block';
                        this.fen = this.$refs.chessboard.setMoveCommand(parseInt(href) + ",0,0");
                        return true;
                    } else if (href.includes('#')) {
                        href = href.substring(href.indexOf("#"));
                        href = href.substring(1, href.length);
                        // console.log("cmd : " + href);
                        this.fen = this.$refs.chessboard.scrollToAnchor(href);
                        return true;
                    } else if (href.includes('contents_href')) {
                        // console.log("aici");
                        href = href.substring(href.indexOf("contents_href"));
                        href = href.substring("contents_href".length + 1, href.length - 1);
                        // console.log(href);
                        this.chapterNumber = parseInt(href);
                        this.loadChapter();
                        return true;
                    }
                }

                return false;
            },
            onBookClick(event) {

                if (this.chapterNumber === 0) {
                    this.showToc();
                } else {
                    if (event.target.tagName.toLowerCase() === 'a') {

                        if (this.handleOnMoveClick(event.target.href)) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    } else {
                        let parent = event.target.parentElement;

                        if (parent !== undefined) {
                            if (parent.tagName.toLowerCase() === 'a') {
                                if (this.handleOnMoveClick(parent.href)) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                }
                            }
                        }
                    }
                }
            },
            extractChapter(event) {
                let f = navigator.userAgent.search("Firefox");
                var href = '';
                if (f > -1) {

                    if (event.target.nodeName.toLowerCase() === 'a') {
                        href = event.target.outerHTML;
                        href = href.substring(href.indexOf('"') + 1, href.lastIndexOf('"') + 1);
                    } else {
                        let parent = event.target.parentElement;

                        if (parent.nodeName.toLowerCase() === 'a') {
                            href = parent.outerHTML;
                            href = href.substring(href.indexOf('"') + 1, href.lastIndexOf('"') + 1);
                        }
                    }

                } else {
                    if (event.target.nodeName.toLowerCase() === 'a') {
                        href = event.target.href;
                    } else {
                        let parent = event.target.parentElement;
                        if (parent.nodeName.toLowerCase() === 'a') {
                            href = parent.href;
                        }
                    }
                }

                if (href) {
                    href = href.substring(href.indexOf("href"));
                    href = href.substring(5, href.length - 1);
                    return parseInt(href);
                } else {
                    return -1;
                }
            },
            onTocClick(event) {
                let newChapterNumber = this.extractChapter(event);

                if (newChapterNumber >= 0) {

                    if (this.chapterNumber !== newChapterNumber) {
                        this.chapterNumber = newChapterNumber;
                        this.updateScrollTime = true;
                        localStorage.removeItem('scrollTop');
                        this.loadChapter();
                    }
                    event.preventDefault();
                    this.popupActive = false;
                } else {
                    event.stopPropagation();
                    event.preventDefault();

                    this.$vs.notify({
                        title: 'Error',
                        text: 'Unexpected Error',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                }

            },
            nextChapter() {
                this.chapterNumber++;
                this.loadChapter();
            },
            previousChapter() {
                this.chapterNumber--;
                this.loadChapter();
            },
            loadChapter(chapter) {
                if (chapter !== undefined) {
                    this.chapterNumber = chapter;
                }

                if (this.chapterNumber === 0) {
                    let chapter = {
                        bookId: this.bookId,
                        file: this.$store.state.books.bookMappings.cover.file
                    };

                    this.$store.dispatch('books/loadChapterContent', chapter, {root: true});
                } else {
                    for (var i = 0; i < this.$store.state.books.bookMappings.chapterMappings.length; i++) {

                        if (this.chapterNumber === this.$store.state.books.bookMappings.chapterMappings[i].chapter) {
                            let chapter = {
                                bookId: this.bookId,
                                file: this.$store.state.books.bookMappings.chapterMappings[i].file
                            };

                            this.$store.dispatch('books/loadChapterContent', chapter, {root: true});
                        }
                    }
                }
            },
            showToc() {
                this.popupActive = true;
            }
        }
    }
</script>
